@use "./break-points" as *;

:root {
    --font-size: 12;
    --browser-font-size: 16;

    @media #{$media-max-sm} {
        --font-size: 16;
    }
}

html,
body {
    width: 100%;
    height: 100%;
    color: #575d6d;
    overflow: hidden;
    font-size: calc(100% * var(--font-size) / var(--browser-font-size));
    font-family: Tahoma, Verdana, Segoe, sans-serif;
}

*,
input,
button {
    font-size: 1rem;
}

input {
    color: #575d6d;
}

textarea {
    resize: both;
}

fieldset {
    padding: 0 1rem;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    padding: 0;
    margin: 0;
    font-weight: 400;
}

h1 {
    font-size: 2.1rem;
    /*padding-bottom: 2.1rem;*/
    padding-bottom: 1rem;

    @media (max-width: $sm) {
        font-size: 2rem;
        padding-bottom: 1rem;
    }
}

h2 {
    font-size: 1.8rem;
    /*padding-bottom: 1.8rem;*/
    padding-bottom: 1rem;

    @media (max-width: $sm) {
        padding-bottom: 0.9rem;
    }
}

h3 {
    font-size: 1.5rem;
    /*padding-bottom: 1.5rem;*/
    padding-bottom: 1rem;

    @media (max-width: $sm) {
        padding-bottom: 0.75rem;
    }
}

h4 {
    font-size: 1.2rem;
    /*padding-bottom: 1.2rem;*/
    padding-bottom: 1rem;

    @media (max-width: $xs) {
        padding-bottom: 0.6rem;
    }
}

a {
    color: #575d6d;
    text-decoration: underline;
}

label {
    font-weight: bold;
}

hr {
    border: none;
    box-shadow: inset 0 0 3px 0 rgba(0, 0, 0, 0.15);
    height: 2px;
    margin: 1rem 0;
}